module.exports = __webpack_public_path__ + "img/check_solid.5655d40b.svg";